import { helpers } from "../../common/lib";
import getInitialState from "../get-initial-state";
import { actionTypes } from "./actions";

const initialState = getInitialState.list();

export default function (state = initialState, action) {
    switch (action.type) {
        case actionTypes.ALT_ASSET_ITEM_CLEAR: {
            return { ...state, item: null };
        }
        case actionTypes.ALT_ASSET_ITEM_SET: {
            const { altAsset } = action.payload;
            return { ...state, item: altAsset };
        }
        case actionTypes.ALT_ASSET_ITEM_UPDATE: {
            const { altAsset } = action.payload;
            const { item } = state;
            return { ...state, item: { ...item, ...altAsset } };
        }
        case actionTypes.ALT_ASSET_GET_BY_ID_SUCCESS: {
            const { altAsset } = action.payload;
            return helpers.mergeListReducer(state, [altAsset]);
        }
        case actionTypes.ALT_ASSET_PATCH_SUCCESS: {
            const { altAsset } = action.payload;
            const index = state.byId[altAsset.id];
            if (index == null) return state;
            const nextData = [...state.data];
            nextData[index] = { ...state.data[index], ...altAsset };
            return { ...state, data: nextData };
        }
        case actionTypes.ALT_ASSETS_MERGE:
        case actionTypes.ALT_ASSETS_BULK_UPDATE_POST_SUCCESS: {
            const { altAssets } = action.payload;
            return helpers.mergeListReducer(state, altAssets);
        }
        case actionTypes.ALT_ASSETS_CLEAR: {
            return initialState;
        }

        case actionTypes.ALT_ASSETS_GET_SUCCESS:
        case actionTypes.ALT_ASSETS_SET: {
            const { altAssets } = action.payload;
            return helpers.getListReducer(initialState, altAssets);
        }
        case actionTypes.ALT_ASSET_UPDATE_STORE: {
            const { altAsset } = action.payload;

            return {
                ...state,
                data: state.data.map((item) => {
                    const updated = altAsset.find((a) => a.id === item.id);
                    if (updated) {
                        return updated;
                    }
                    return item;
                })
            };
        }
        default: {
            return state;
        }
    }
}
